import Api from '@/api'
import Store from '@/store'

import Storage from '@/helpers/storage'

import Firebase from '@/modules/firebase'
import I18n from '@/modules/i18n'
import Loop from '@/modules/loop'
import Tag from '@/modules/tag'
import Tracking from '@/modules/tracking'
import UserAgent from '@/modules/userAgent'
import ENUM from '@/assets/ENUM'

const auth = {

    Statuses: {
        SUCCESS: 1,
        UNKNOWN_ERROR: 0,
        INVALID_CREDENTIALS: 2,
        TIMEOUT: 3,
        APPLICATION_PASSWORD: 4,
        IMAP_DISABLED: 5
    },

    errorToStatus: function (error) {
        switch (error) {
            case 'invalid_credentials':
                return this.Statuses.INVALID_CREDENTIALS
            case 'timeout':
                return this.Statuses.TIMEOUT
            case 'application_password':
                return this.Statuses.APPLICATION_PASSWORD
            case 'imap_disabled':
                return this.Statuses.IMAP_DISABLED
            default:
                return this.Statuses.UNKNOWN_ERROR
        }
    },

    redirect: function (to, from, next) {

        Storage.getItem('token') ? next({path: '/newsletters'}) : auth.disconnect()

    },

    connect: async function (Vue, email, password, provider) {

        Tag.infoAll(Vue, 'status_connection_started', provider)

        const device = UserAgent.getDevice()
        const language = I18n.get(Vue)
        const millisecondsToWait = await Firebase.getValue('login_timeout_seconds', 'Number') * 1000 || 60 * 1000
        const deadLineTime = new Date().getTime() + millisecondsToWait
        const millisecondsToDelay = await Firebase.getValue('login_delay_retry_seconds', 'Number') * 1000 || 30 * 1000

        return new Promise((resolve, reject) => connectRec(Vue, {email, password, language, device, provider}, {deadLineTime, millisecondsToDelay}, resolve, reject))
    },

    disconnect: function (requestToServer = true) {
        if (requestToServer) {
            Api.auth.disconnect()
        }
        if (Store) { // fixme: Iphone crash
            Store.dispatch('disconnect')
        }
        Storage.clear()
        Store.dispatch('updateIsConnected', false)
        location.href = '/'

    },

    sendMagicLinkEmail: function (email, lang) {

        return Api.auth.sendMagicLinkEmail(email, lang)

    },

    getMagicLinkUser: function (code) {

        return Api.auth.getMagicLinkUser(code)

    },

    getAuthLink: function (code) {

        return Api.auth.authLongCheck(code)

    },

    deleteEmailAccount: function (email) {

        return Api.auth.deleteEmailAccount(email)
            .then(data => {
                Storage.setItem('aToken', data.token)
                return Loop.start(() => Api.auth.deleteEmailAccountCheck(email))
            })

    },

    microsoftAuth: async function (Vue, aToken) {

        return await postConnection(Vue, aToken)

    },

    microsoftApi: function (Vue, email) {

        Tag.pageViewAmplitude(Vue, 'microsoft')

        const token = Storage.getItem('token') || ''
        const emailStr = encodeURIComponent(email) || ''
        const utmSource = Storage.getItem('utm_source') || ''
        const utmMedium = Storage.getItem('utm_medium') || ''
        const utmCampaign = Storage.getItem('utm_campaign') || ''
        const referrer = Storage.getItem('referrer') || ''
        const device = UserAgent.getDevice()
        const language = I18n.get(Vue)

        window.location.href = `/login/microsoft?token=${token || ''}&email=${emailStr}&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&referrer=${referrer}&device=${device}&language=${language}`

    },

    validConsent: function (lang, email) {

        const utms = Tracking.getTracking()

        const body = {
            email,
            language: lang,
            device: UserAgent.getDevice()
        }

        return Api.auth.validConsent(body, utms)

    }

}

function connectRec(Vue, {email, password, language, device, provider}, {deadLineTime, millisecondsToDelay}, resolve, reject) {
    return Api.auth.connect(email, password, device, language)
        .then(async data => {
            resolve(await postConnection(Vue, data.token))
        })
        .catch(error => {
            if (error) {
                const errorStatus = auth.errorToStatus(error.message)

                Tag.infoGa(Vue, 'status_connection_failed', provider, errorStatus)

                if (((Date.now() + millisecondsToDelay) < deadLineTime) && (error.message === 'timeout' || error.message === 'unknown_error')) {
                    setTimeout(() => {
                        connectRec(Vue, {email, password, language, device, provider}, {deadLineTime, millisecondsToDelay}, resolve, reject)
                    }, millisecondsToDelay)

                } else {
                    reject(error)
                }
            } else {
                reject(new Error('unknown_error'))
            }
        })
}

export default auth

function postConnection(Vue, aToken) {

    Storage.setItem('aToken', aToken)

    return Loop.start(Api.auth.authCheck)
        .then(data => {

            const result = data.result

            Storage.setItem('token', result.token)
            Store.dispatch('setUser', result.user)
            Store.dispatch('updateIsConnected', true)

            const provider = result.user.accounts[0].provider
                            switch (result.status) {
                    case ENUM.LOGIN_STATUS.CREATED:
                        Storage.setItem('userHash', result.user.hash) //gtm pixels
                        Tag.accountCreated(provider)
                        Tag.accountCreatedAmplitude(Vue, provider)
                        break
                    case ENUM.LOGIN_STATUS.ASSOCIATED:
                        Tag.accountAssociated()
                        Tag.accountAssociatedAmplitude(Vue)
                        break
                    case ENUM.LOGIN_STATUS.IMPORTED:
                        Tag.accountImportedAmplitude()
                        break
                    case ENUM.LOGIN_STATUS.RECONNECTED:
                        Tag.accountReconnectedAmplitude()
                        break
                    case ENUM.LOGIN_STATUS.RECONNECTED_INVALID_GRANT:
                        Tag.accountReconnectedWasInvalidGrantAmplitude()
                        break
                    case ENUM.LOGIN_STATUS.MAGIC_LINK:
                        Tag.accountReconnectedMagicLinkAmplitude()
                        break
                    default:
                        //TODO: delete "default" after server update with "status" in /auth/check response
                        if (result.new) {
                            Storage.setItem('userHash', result.user.hash) //gtm pixels
                            Tag.accountCreated(provider)
                            Tag.accountCreatedAmplitude(Vue, provider)
                        }
    
                        if (result.association) {
                            Tag.accountAssociated()
                            Tag.accountAssociatedAmplitude(Vue)
                        }
                }
        })
}
